import { Container as MUIcontainer, ContainerProps as MUIContainerProps } from '@mui/material';

export type ContainerProps = MUIContainerProps;

export const Container = MUIcontainer;
